export const nounPath = (nounId: Number) => `/sznoun/${nounId}`;
